import { InjectionToken } from '@angular/core';

export interface NgTicketsConfig {
  applicationName: string;
}

export const NgTicketsConfigService = new InjectionToken<NgTicketsConfig>('NgTicketsConfig');
